<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div
                class="fieldset"
                [ngClass]="{
                    'container-CustomerIdentification-regex':
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.CustomerIdentification) &&
                        enumHelper.areEquals(SearchMode, _context.item.searchMode, SearchMode.RegEx),
                    'container-CustomerIdentification-keyword':
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.CustomerIdentification) &&
                        enumHelper.areNotEquals(SearchMode, _context.item.searchMode, SearchMode.RegEx),
                    'container-DocumentTypeIdentification-regex':
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.DocumentTypeIdentification) &&
                        enumHelper.areEquals(SearchMode, _context.item.searchMode, SearchMode.RegEx),
                    'container-DocumentTypeIdentification-keyword':
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.DocumentTypeIdentification) &&
                        enumHelper.areNotEquals(SearchMode, _context.item.searchMode, SearchMode.RegEx),
                    'container-AttributesAssignment-regex':
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AttributesAssignment) &&
                        enumHelper.areEquals(SearchMode, _context.item.searchMode, SearchMode.RegEx),
                    'container-AttributesAssignment-keyword':
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AttributesAssignment) &&
                        enumHelper.areNotEquals(SearchMode, _context.item.searchMode, SearchMode.RegEx),
                    'container-AutoLink': enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AutoLink),
                    'container-creation': _context.item.type === null,
                }">
                <div class="form-item form-item-name form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Nom</mat-label>
                        <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required tabindex="1" />
                        @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="nameTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                </div>

                <div class="form-item form-item-type form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Type</mat-label>
                        <mat-select data-select-typeId formControlName="type" required tabindex="2" (selectionChange)="onTypeChanged($event)">
                            @for (type of processTypes; track type) {
                                <mat-option data-select-listing-type-option [value]="type.value">
                                    {{ type.text }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (formGroupErrors?.type?.required && (formGroup.controls['type']?.dirty || formGroup.controls['type'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Type' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="typeTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                </div>

                <!-- <div class="form-item">
        <mat-form-field>
          <textarea matInput data-input-definition type="text" placeholder="Définition" formControlName="definitionJson"
          autocomplete="off" required rows="4" tabindex="3"></textarea>
          <mat-error data-input-title-error *ngIf="formGroupErrors?.definitionJson?.required && (formGroup.controls['definitionJson']?.dirty || formGroup.controls['definitionJson'].touched)">
            Le champ 'Définition' est obligatoire
          </mat-error>
        </mat-form-field>
      </div> -->

                @if (_context.item.type !== null) {
                    @if (enumHelper.areNotEquals(ProcessType, _context.item.type, ProcessType.CustomerIdentification)) {
                        <div class="form-item form-item-customer form-item-help">
                            <!-- <app-mat-filterable-select [elements]="_context.customers" label="Client" formControlName="customerId" ngDefaultControl className="with-info-icon filterable-select" tabindex="3"></app-mat-filterable-select> -->
                            <mat-form-field class="with-info-icon">
                                <mat-label>Client</mat-label>
                                <mat-select data-select-customerId formControlName="customerId" tabindex="3">
                                    <mat-option [value]="">Tous</mat-option>
                                    @for (customer of _context.customers; track customer) {
                                        <mat-option data-select-listing-customerId-option [value]="customer.id">
                                            {{ customer.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="customerIdTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                        </div>
                    }
                    @if (
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AttributesAssignment) ||
                        enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AutoLink)
                    ) {
                        <div class="form-item form-item-documentType form-item-help">
                            <mat-form-field class="with-info-icon">
                                <mat-label>Type de document</mat-label>
                                <mat-select data-select-documentTypeId formControlName="documentTypeId" tabindex="4">
                                    <mat-option [value]="">Tous</mat-option>
                                    @for (documentType of _context.documentTypes; track documentType) {
                                        <mat-option data-select-listing-documentTypeId-option [value]="documentType.id">
                                            {{ documentType.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="documentTypeIdTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                        </div>
                    }
                    <div class="form-item form-item-issuer form-item-help">
                        <mat-form-field class="with-info-icon">
                            <mat-label>Emetteur</mat-label>
                            <input matInput data-input-issuer type="text" formControlName="issuer" autocomplete="off" tabindex="5" />
                        </mat-form-field>
                        <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="issuerTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                    </div>
                    <div class="form-item form-item-searchMode form-item-help">
                        <mat-form-field class="with-info-icon">
                            <mat-label>Mode de recherche</mat-label>
                            <mat-select data-select-searchMode formControlName="searchMode" tabindex="7" required (selectionChange)="onSearchModeChanged($event)">
                                @for (searchMode of searchModes; track searchMode) {
                                    <mat-option data-select-listing-searchMode-option [value]="searchMode.value">
                                        {{ searchMode.text }}
                                    </mat-option>
                                }
                            </mat-select>
                            @if (formGroupErrors?.searchMode?.required && (formGroup.controls['searchMode']?.dirty || formGroup.controls['searchMode'].touched)) {
                                <mat-error>Le champ 'Mode de recherche' est obligatoire</mat-error>
                            }
                        </mat-form-field>
                        @if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AttributesAssignment)) {
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="searchModeTooltipContentAttributesAssignment" tooltipPosition="right"></fa-icon>
                        } @else if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.CustomerIdentification)) {
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="searchModeTooltipContentCustomerIdentification" tooltipPosition="right"></fa-icon>
                        } @else if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.DocumentTypeIdentification)) {
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="searchModeTooltipContentDocumentTypeIdentification" tooltipPosition="right"></fa-icon>
                        } @else if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AutoLink)) {
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="searchModeTooltipContentAutoLink" tooltipPosition="right"></fa-icon>
                        }
                    </div>
                    @if (_context.item.searchMode && enumHelper.areNotEquals(SearchMode, _context.item.searchMode, SearchMode.None)) {
                        <div class="form-item form-item-criteriaSearchZones form-item-help">
                            <div class="criteriaSearchZones-container">
                                <app-swap-chip-lists formControlName="criteriaSearchZones" ngDefaultControl (onchange)="oncriteriaSearchZonesChange($event)"></app-swap-chip-lists>
                                @if (
                                    formGroupErrors?.criteriaSearchZones?.required &&
                                    (formGroup.controls['criteriaSearchZones']?.dirty || formGroup.controls['criteriaSearchZones'].touched)
                                ) {
                                    <mat-error>Le champ 'Zones de recherche' est obligatoire</mat-error>
                                }
                            </div>
                        </div>
                        <div class="form-item form-item-searchExpression form-item-help">
                            <mat-form-field class="with-info-icon">
                                <mat-label>Expression de recherche</mat-label>
                                <input matInput data-input-searchExpression type="text" formControlName="searchExpression" autocomplete="off" tabindex="8" required />
                            </mat-form-field>
                            @if (formGroupErrors?.searchExpression?.required && (formGroup.controls['searchExpression']?.dirty || formGroup.controls['searchExpression'].touched)) {
                                <mat-error>Le champ 'Expression de recherche' est obligatoire</mat-error>
                            }
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="searchExpressionTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                        </div>
                        <label class="form-zone-label search-options-label">Options de recherche</label>
                        @if (enumHelper.areEquals(SearchMode, _context.item.searchMode, SearchMode.KeyWord)) {
                            <div class="form-item form-item-wholeWordOnlyEnabled form-item-help">
                                <mat-checkbox class="with-info-icon accent-button" formControlName="wholeWordOnlyEnabled" tabindex="9">Mot entier uniquement</mat-checkbox>
                                <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="wholeWordOnlyEnabledTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                            </div>
                        }
                        <div class="form-item form-item-sensitiveCaseEnabled form-item-help">
                            <mat-checkbox class="with-info-icon accent-button" formControlName="sensitiveCaseEnabled" tabindex="10">Sensible à la casse</mat-checkbox>
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="sensitiveCaseEnabledTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                        </div>
                        <div class="form-item form-item-specialCaractersIgnored form-item-help">
                            <mat-checkbox class="with-info-icon accent-button" formControlName="specialCaractersIgnored" tabindex="11">
                                Ignorer les différences liées aux caractères spéciaux
                            </mat-checkbox>
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="specialCaractersIgnoredTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                        </div>
                        @if (enumHelper.areEquals(SearchMode, _context.item.searchMode, SearchMode.KeyWord)) {
                            <div class="form-item form-item-minorDifferencesAccepted form-item-help">
                                <mat-checkbox class="with-info-icon accent-button" formControlName="minorDifferencesAccepted" tabindex="12">
                                    Accepter les différences mineures
                                </mat-checkbox>
                                <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="minorDifferencesAcceptedTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                            </div>
                        }
                        @if (
                            enumHelper.areEquals(SearchMode, _context.item.searchMode, SearchMode.KeyWord) &&
                            enumHelper.areNotEquals(ProcessType, _context.item.type, ProcessType.CustomerIdentification)
                        ) {
                            <div class="form-item form-item-pluralizeEnabled form-item-help">
                                <mat-checkbox class="with-info-icon accent-button" formControlName="pluralizeEnabled" tabindex="13">Singulier/pluriel</mat-checkbox>
                                <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="pluralizeEnabledTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
                            </div>
                        }
                    }
                    @if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.CustomerIdentification)) {
                        <div class="form-item form-item-identifiedCustomerId form-item-help">
                            <app-mat-filterable-select
                                [elements]="_context.customers"
                                label="Client reconnu"
                                formControlName="identifiedCustomerId"
                                ngDefaultControl
                                className="with-info-icon filterable-select"></app-mat-filterable-select>
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="identifiedCustomerTooltipContent" tooltipPosition="right"></fa-icon>
                        </div>
                    }
                    @if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.DocumentTypeIdentification)) {
                        <div class="form-item form-item-identifiedDocumentTypeId form-item-help">
                            <mat-form-field class="with-info-icon">
                                <mat-label>Type de document reconnu</mat-label>
                                <mat-select data-select-identifiedDocumentTypeId formControlName="identifiedDocumentTypeId" tabindex="14" required>
                                    @for (documentType of _context.documentTypes; track documentType) {
                                        <mat-option data-select-listing-identifiedDocumentTypeId-option [value]="documentType.id">
                                            {{ documentType.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                                @if (
                                    formGroupErrors?.identifiedDocumentTypeId?.required &&
                                    (formGroup.controls['identifiedDocumentTypeId']?.dirty || formGroup.controls['identifiedDocumentTypeId'].touched)
                                ) {
                                    <mat-error>Le champ 'Type de document reconnu' est obligatoire</mat-error>
                                }
                            </mat-form-field>
                            <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="identifiedDocumentTypeTooltipContent" tooltipPosition="right"></fa-icon>
                        </div>
                    }
                    @if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AttributesAssignment)) {
                        <div class="form-item form-item-attributesAssignment form-item-help">
                            <div class="assignment-table-container">
                                <app-attribute-assignment-table
                                    formControlName="attributesAssignment"
                                    [attributes]="_context.attributes"
                                    [folderStates]="_context.folderStates"
                                    ngDefaultControl
                                    (attributesChanged)="onAttributesChanged($event)"></app-attribute-assignment-table>
                                @if (
                                    formGroupErrors?.attributesAssignment?.required &&
                                    (formGroup.controls['attributesAssignment']?.dirty || formGroup.controls['attributesAssignment'].touched)
                                ) {
                                    <mat-error>Le champ 'Assignation d'attributs' est obligatoire</mat-error>
                                }
                            </div>
                        </div>
                    }
                    @if (enumHelper.areEquals(ProcessType, _context.item.type, ProcessType.AutoLink)) {
                        <div class="form-item form-item-autoLink">
                            <app-auto-link-definition
                                [context]="_context"
                                formControlName="autoLinkDatas"
                                ngDefaultControl
                                (datasChanged)="onAutoLinkDatasChanged($event)"></app-auto-link-definition>
                        </div>
                    }
                }
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
